import { createAppSlice } from '../../app/createAppSlice'

const initialState = {on: false, components: ""};

const globalLoadingSlice = createAppSlice({
    name: "globalLoading",
    initialState,
    reducers: create => ({
        globalLoadingOn: create.reducer((state) => { state.on = true; }),
        globalLoadingOff: create.reducer((state) => { state.on = false; }),
        componentLoadingOn: create.reducer((state, action) => {
            state.components += action.payload
        }),
        componentLoadingOff: create.reducer((state, action) => {
            state.components = state.components.replace(action.payload, "")
        }),
        componentLoadingOffAll: create.reducer((state, action) => {
            state.components = state.components.replaceAll(action.payload, "")
        }),
        cancelComponentLoading: create.reducer((state) => { state.components = ""})
    }),
    selectors: {
        selectGlobalLoading: globalLoading => globalLoading.on,
        selectComponentLoading: globalLoading => globalLoading.components.length
    },
})

export const { globalLoadingOn, globalLoadingOff, componentLoadingOn, componentLoadingOff,
     componentLoadingOffAll, cancelComponentLoading } = globalLoadingSlice.actions

export const { selectGlobalLoading, selectComponentLoading } = globalLoadingSlice.selectors

export default globalLoadingSlice